module.exports = __webpack_public_path__ + "048a8480560859b621adf8db9f0a6154.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Carousel/images/1.jpg
// module id = ./src/components/Carousel/images/1.jpg
// module chunks = 0